import { forwardRef } from 'react';
import MemberSelectorModal from './MemberSelectorModal';
import MemberSelectorInput from './MemberSelectorInput';
import type { MemberSelectorProps, MemberSelectorRef } from './types';
export type { MemberSelectorInputProps } from './MemberSelectorInput';

/**
 * MemberSelector - 人员选择器组件
 *
 * @example
 * // 单选模式
 * <MemberSelector
 *   visible={visible}
 *   mode="single"
 *   onCancel={() => setVisible(false)}
 *   onConfirm={(member) => console.log(member)}
 * />
 *
 * @example
 * // 多选模式
 * <MemberSelector
 *   visible={visible}
 *   mode="multiple"
 *   maxCount={10}
 *   defaultValue={selectedMembers}
 *   onCancel={() => setVisible(false)}
 *   onConfirm={(members) => console.log(members)}
 * />
 */
const MemberSelector = forwardRef<MemberSelectorRef, MemberSelectorProps>(
  (props, ref) => {
    return <MemberSelectorModal ref={ref} {...props} />;
  }
);

MemberSelector.displayName = 'MemberSelector';

export { MemberSelectorInput };
export default MemberSelector;
